<template>
  <!-- <div class="d-flex justify-center">
    <div>
      <v-select
        v-model="selectedCategories"
        :items="uniqueCategories"
        label="Filter kategorija"
        item-text="name"
        item-value="id"
        outlined
        multiple
        dense
        style="max-width: 250px"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0" style="height: 26px">
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text text-caption">
            (+{{ selectedCategories.length - 1 }})
          </span>
        </template>
        <template v-slot:item="{ item }">
          <div
            style="width: 100%; height: 35px"
            @click="setCategoryFilters(item)"
          >
            {{ item.name }}
          </div>
        </template>
      </v-select>
    </div>
  </div> -->

  <div class="d-flex justify-center">
    <div>
      <v-select
        class="filter-select"
        outlined
        multiple
        dense
        hide-details
        v-model="selectedCategories"
        :items="uniqueCategories"
        label="Filter kategorija"
        item-text="name"
        item-value="id"
        @change="setCategoryFilters()"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text text-caption">
            (+{{ selectedCategories.length - 1 }})
          </span>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import { df } from '@/plugins/firebase'
import state from '@/state'

export default {
  data () {
    return {
      categories: [],
      uniqueCategories: [],
      categoryFilters: [],
      localItems: [],
      initialItems: [],
      filters: [],
      location: null,
      selectedCategories: []
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    init (items) {
      this.localItems = [...items]
      this.initialItems = [...items]
    },

    setCategoryFilters () {
      // if (this.categoryFilters.includes(item.id)) {
      //   this.categoryFilters.splice(this.categoryFilters.indexOf(item.id), 1)
      // } else {
      //   this.categoryFilters.push(item.id)
      // }
      // if (this.categoryFilters.length === 0) {
      //   this.$emit('setIdsForFilter', [])
      // } else {
      //   this.$emit('setIdsForFilter', [...this.categoryFilters])
      // }

      if (this.selectedCategories.length === 0) {
        this.$emit('setIdsForFilter', [])
      } else {
        this.$emit('setIdsForFilter', [...this.selectedCategories])
      }
    },

    async getAllCategories () {
      const snapshot = await df.doc(`company_categories/${state.getCurrentCompany().id}`).get()
      if (snapshot) {
        const document = snapshot.data()
        for (const property in document.categories) {
          const category = { id: document.categories[property].id, name: document.categories[property].name }
          this.uniqueCategories.push(category)
        }
        this.uniqueCategories = this.uniqueCategories.sort((a, b) => a.name.localeCompare(b.name))
      }
    },

    async getCategoriesByItemId (items, locationId) {
      const fileredItems = []
      const locId = locationId || state.getPointOfSale().id

      const query = df.collection(`location_pricelist/${locId}/items`)
        .where('active', '==', true)
        .where('status', '==', 'OK')

      const documentSnapshots = await query.get()

      if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
        const filters = this.selectedCategories.flat()
        documentSnapshots.docs.forEach((doc) => {
          const data = doc.data()
          const priceListItem = items.find(i => {
            const dotIndex = i.id.indexOf('.')
            const baseId = dotIndex > -1 ? i.id.substring(0, dotIndex) : i.id
            return baseId === data.id
          })
          if (priceListItem && filters.length > 0) {
            const categoryIds = data.category_ids || []
            categoryIds.forEach(catId => {
              if (filters.includes(catId)) {
                fileredItems.push(priceListItem)
              }
            })
          }
        })
      }

      return fileredItems.flat()
    }
  },

  created () {
    this.getAllCategories()
  }
}
</script>

<style scoped>
/* Filter Select Styling */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 36px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

.filter-select >>> .v-chip {
  height: 24px !important;
  font-size: 12px !important;
}
</style>
